import Index from "./Index.vue";
import Show from "./Show.vue";

export default [
  {
    path: "",
    name: "UsersTrainingsIndex",
    component: Index,
    meta: {
      title: "研修一覧",
      subtitle: "TRAINING",
      tree: [],
    },
  },
  {
    path: "show/:id",
    name: "UsersTrainingsShow",
    component: Show,
    meta: {
      title: "詳細",
      tree: [
        {
          name: "UsersTrainingsIndex",
          title: "研修一覧",
        },
      ],
    },
  },
];
